import React from "react";
import logo from "../../../../../assets/logo.png";
import BackIcon from "../../../../../assets/affiliates/backIcon.svg";
import { useTranslation } from "react-i18next";
import { useUpdateUserMutation } from "../../../../../store/api/authApiSlice";
import { REACT_APP_REDIRECT_URL } from "../../../../../helpers/config";

export const AffiliatesJoinTermsStep = ({
  handleGoToNextSlide,
  handleGoToPrevSlide,
}: {
  handleGoToNextSlide: () => void;
  handleGoToPrevSlide: () => void;
}) => {
  const { i18n, t } = useTranslation(["affiliates"]);
  const isRTL = i18n.dir() === "rtl";

  const [updateUser] = useUpdateUserMutation();

  const handleApply = async () => {
    const userString = await (localStorage.getItem("user") ||
      sessionStorage.getItem("user"));
    const user = await (userString ? JSON.parse(userString) : null);

    const code = crypto.randomUUID();
    try {
      if (user) {
        const updatedUser = await updateUser({
          affiliateLink: `${
            REACT_APP_REDIRECT_URL ? REACT_APP_REDIRECT_URL : "localhost:3001"
          }/home?affiliatesCode=${code}`,
        }).unwrap();

        localStorage.setItem("user", JSON.stringify(updatedUser));
      }

      handleGoToNextSlide();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="join-affiliates-popup-content-wrapper">
      <div className="join-affiliates-popup-terms-wrapper">
        <div
          className="join-affiliates-popup-back-btn-container"
          onClick={handleGoToPrevSlide}
          style={{
            left: isRTL ? "auto" : "30px",
            right: isRTL ? "30px" : "auto",
          }}
        >
          <img
            src={BackIcon}
            style={{
              transform: isRTL ? "scaleX(-1)" : " scaleX(1)",
            }}
          />
          <div>{t("back")}</div>
        </div>
        <div className="join-affiliates-popup-terms-title-container">
          <img
            src={logo}
            style={{
              width: "97px",
              height: "60px",
            }}
          />
          <div
            className="join-affiliates-popup-terms-title"
            style={{
              fontFamily: isRTL ? "Noto Sans Hebrew" : "Frank Ruhl Libre",
            }}
          >
            {t("terms_and_conditions")}
          </div>
        </div>

        <div className="join-affiliates-popup-terms-main-container">
          <div className="inner-scroll">
            <div className="join-affiliates-popup-terms-main-container-title">
              {t("general_terms")}
            </div>
            <div className="join-affiliates-popup-terms-main-container-desc">
              {t("general_terms_info")}
            </div>
            <div className="join-affiliates-popup-terms-main-container-title">
              {t("payment_details")}
            </div>
            <div>{t("payment_details_info")}</div>
          </div>
        </div>
        <div className="affiliates-apply-btn" onClick={handleApply}>
          {t("apply")}
        </div>

        <div className="join-affiliates-popup-terms-add-info">
          {t("terms_desc")}
        </div>
      </div>
    </div>
  );
};
